<template> 
  <div class="leftside-menu " >    
      <!-- LOGO -->
      <a href="/" class="logo text-center logo-light">
          <span class="logo-lg">
              <img src="/assets/images/logo.png" alt="" height="80" width="230">
              <!-- <span>স্বাস্থ্যকর প্রতিদিন</span> -->
          </span>
          <span class="logo-sm">
              <img src="/assets/images/logo_sm.png" alt="" height="16">
          </span>
      </a>

      <!-- LOGO -->
      <!-- <a href="/" class="logo text-center logo-dark">
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="16">
          </span>
          <span class="logo-sm">
              <img src="assets/images/logo_sm_dark.png" alt="" height="16">
          </span>
      </a> -->

      <div class="h-100 scrollbar-width-thin" style="overflow-y: auto;" id="leftside-menu-container" data-simplebar> 
          <!--- Sidemenu --> 
          <ul class="side-nav crollbar-width-thin">  
              <li class="side-nav-item" v-for="route in routes" :key="route.name">
                
                  <a data-bs-toggle="collapse" :href="'#' + route.name" aria-expanded="false"  class="side-nav-link" v-if="route.children.length > 0" @click="checkParrentNav(route.name)">
                      <i v-if="route.icon_name" v-bind:class="route.icon_name"></i> 
                      <span> &nbsp  &nbsp{{route.name}}  </span>
                      <span class="menu-arrow"></span>
                  </a>
                  
                  <router-link :to="route.path" class="side-nav-link" v-else>
                    <i v-if="route.icon_name" v-bind:class="route.icon_name"></i>
                    <span> &nbsp  &nbsp{{route.name}}  </span>
                  </router-link> 

                  <div class="collapse" :id="route.name">
                      <ul class="side-nav-second-level">
                          <li v-for="children in route.children" :key="children.name">
                            <a data-bs-toggle="collapse" :href="'#' + children.name" aria-expanded="false"  class="side-nav-link" v-if="children.children.length > 0" @click="checkParrentNav(children.name)">
                                <i v-if="children.icon_name" v-bind:class="children.icon_name"></i> 
                                <span> &nbsp  &nbsp{{children.name}}  </span>
                                <span class="menu-arrow"></span>
                            </a>
                            <router-link :to="children.path" class="side-nav-link" v-else>
                              <span class="fa fa-user mr-1"></span> &nbsp {{children.name}}
                            </router-link> 
                            
                            <div class="collapse" :id="children.name">
                              <ul class="side-nav-third-level">
                                  <li v-for="subChildren in children.children" :key="subChildren.name">
                                    <router-link :to="subChildren.path" class="side-nav-link">
                                      <span class="fa fa-user mr-1"></span> &nbsp {{subChildren.name}}
                                    </router-link> 
                                  </li> 
                              </ul>
                          </div> 
                          </li> 
                      </ul>
                  </div>                  
                  
              </li>  

              <!-- Custom Route -->
              <!-- <li class="side-nav-item">
                
                <a data-bs-toggle="collapse" href="#test-child" aria-expanded="false"  class="side-nav-link">
                    <i class="fa fa-link"></i> 
                    <span> Test Parent Link  </span>
                    <span class="menu-arrow"></span>
                </a>

                <div class="collapse" id="test-child">
                    <ul class="side-nav-second-level">
                        <li>
                          <a data-bs-toggle="collapse" href="#test-sub-child" aria-expanded="false"  class="side-nav-link">
                              <i class="fa fa-link"></i> 
                              <span> Test Child Link  </span>
                              <span class="menu-arrow"></span>
                          </a>
                          <div class="collapse" id="test-sub-child">
                            <ul class="side-nav-third-level">
                              <li>
                                <router-link to="/test-sub-child-link" >
                                  <span class="fa fa-user mr-1"></span> Test Sub Child Link
                                </router-link> 
                              </li> 
                            </ul>
                          </div>
                        </li> 
                    </ul>
                </div>                  
                
              </li>   -->
          </ul> 

          <div class="clearfix"></div>

      </div>
      <!-- Sidebar -left -->
  </div>   
</template>
<script>
import {mapGetters} from "vuex"
import { defineComponent } from 'vue'
import { FadeInOut } from 'vue3-transitions'
import About from "@/views/page/RolePermission.vue";  
export default {
  name: 'NavigationTemplate',
  props: {
    msg: String
  },
  components: { FadeInOut },
  data() {
    return {
      routes: [],
      activeClass:''
    };

  },
  methods:{  
    checkParrentNav(name){
      // console.log('checkParrentNav', name)
      // console.log('UserMenuAndPermissions', this.$store.getters.userAllPermissions[name][0].children)
    }
  },
  computed: {
    computedClass() {
      if(this.currentRouteName =='/pos' || this.currentRouteName =='/pos-for-prescription'){
        return 'active';
      }else{
        return '';
      }  
    },
    currentRouteName() {
        return this.$route.path;
    }
  },
  mounted() { 
     
  },
  created(){   
    //this.$router.removeRoute('Outlet')
    this.routes = this.$router.options.navigations
  }
}

</script>
 
<style>
  .logo {
    line-height: 1.5 !important;
  }
</style>